"use client";

import Button from "@/components/library/Button";
import clsx from "clsx";
import type { JobType } from "@/utils/jobsPublic";
import type { SupportedLanguage } from "@/utils/library/languages";
import { getTranslatedPath } from "@/utils/routes";
import { useTranslation } from "react-i18next";

export type JobFilterValue = "all" | JobType;

type JobFilterTabsProps = {
  value: JobFilterValue;
  lang: SupportedLanguage;
  onChange: (value: JobFilterValue) => void;
};

const FILTERS: JobFilterValue[] = ["all", "gtm", "engineering", "cx"];

export default function JobFilterTabs({
  value,
  lang,
  onChange,
}: Readonly<JobFilterTabsProps>) {
  const { t } = useTranslation();

  const label = (filter: JobFilterValue) => {
    if (filter === "all") return t("careers.filters.all");
    return t(`careers.filters.${filter}`);
  };

  const hrefForFilter = (filter: JobFilterValue) => {
    const route = filter === "all" ? "/careers" : `/careers/${filter}`;
    return `/${lang}${getTranslatedPath(route, lang)}`;
  };

  return (
    <nav className="flex flex-wrap gap-2" aria-label={t("careers.openPositions")}>
      {FILTERS.map((filter) => (
        <Button
          key={filter}
          href={hrefForFilter(filter)}
          type={value === filter ? "primary" : "none"}
          ariaCurrent={value === filter ? "page" : undefined}
          secondaryAction={() => onChange(filter)}
          className={clsx(
            "border px-4 py-2 text-sm font-medium transition-colors font-monument",
            value === filter
              ? "border-black bg-black text-white"
              : "border-black/10 bg-white text-black hover:border-black/30",
          )}
        >
          {label(filter)}
        </Button>
      ))}
    </nav>
  );
}
